/** @format */

export async function handleResponse(response) {
  const responseData = await response.json();
  console.log('Response', responseData);
  return responseData;
}

export async function handleError(error) {
  console.error('Error', error);
  return new Error(error);
}
